import React from "react";
import moment from "moment";
import { Card, CardContent } from "@/components/ui/card";

const NUM_COLORS = 5;

const SHAPE_DEFS = [
  (isComp: boolean, colorIdx: number) => (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect width="100" height="100" fill={isComp ? "#E5E5E5" : `url(#bgGrad${colorIdx})`} />
      <path d="M50 25 L75 39.5 L75 68.5 L50 83 L25 68.5 L25 39.5 Z" fill={isComp ? "#F5F5F5" : `url(#iconGrad${colorIdx})`} />
    </svg>
  ),
  (isComp: boolean, colorIdx: number) => (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect width="100" height="100" fill={isComp ? "#E5E5E5" : `url(#bgGrad${colorIdx})`} />
      <path d="M50 25 L80 47 L68 82 L32 82 L20 47 Z" fill={isComp ? "#F5F5F5" : `url(#iconGrad${colorIdx})`} />
    </svg>
  ),
  (isComp: boolean, colorIdx: number) => (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect width="100" height="100" fill={isComp ? "#E5E5E5" : `url(#bgGrad${colorIdx})`} />
      <path d="M50 25 L75 39.5 L75 68.5 L50 83 L25 68.5 L25 39.5 Z" fill={isComp ? "#F5F5F5" : `url(#iconGrad${colorIdx})`} />
    </svg>
  ),
  (isComp: boolean, colorIdx: number) => (
    <svg viewBox="0 0 100 100" className="w-full h-full">
      <rect width="100" height="100" fill={isComp ? "#E5E5E5" : `url(#bgGrad${colorIdx})`} />
      <path d="M50 30 L80 80 L20 80 Z" fill={isComp ? "#F5F5F5" : `url(#iconGrad${colorIdx})`} />
    </svg>
  )
];

interface QuizCardProps {
  quiz: any;
  index: number;
  colorIndex?: number;
  isCompleted?: boolean;
  isAdmin?: boolean;
  actions: React.ReactNode;
  statusClass?: string;
}

const QuizCard: React.FC<QuizCardProps> = ({ quiz, index, colorIndex, isCompleted = false, isAdmin = false, actions, statusClass }) => {
  const shapeFn = SHAPE_DEFS[index % SHAPE_DEFS.length];
  const gradientIndex = ((colorIndex ?? index) % NUM_COLORS) + 1; // 1-based for gradient IDs
  const isUnavailable = statusClass === 'unavailable';

  return (
    <Card className={`mb-2 transition-all duration-300 transform ${isCompleted || isUnavailable ? 'opacity-80 bg-muted/40 shadow-none' : 'bg-card shadow-none hover:shadow-lg hover:-translate-y-1'}`}>
      <CardContent className="px-4 py-3 flex items-center justify-between md:flex-row flex-col gap-4">
        <div className="flex items-center gap-5 min-w-0 flex-grow">
          <div className="w-[80px] h-[80px] md:w-[90px] md:h-[90px] flex items-center justify-center rounded overflow-hidden flex-shrink-0">
            {shapeFn(isCompleted || isUnavailable, gradientIndex)}
          </div>
          <div className="flex flex-col gap-1 min-w-0 overflow-hidden">
            <h3 className={`text-base md:text-lg font-semibold m-0 truncate ${isCompleted ? 'text-muted-foreground' : 'text-foreground'}`}>
              {quiz.quiz_name || "Untitled Quiz"}
            </h3>
            <div className="flex flex-wrap items-center text-muted-foreground text-xs md:text-sm">
              <span className="whitespace-nowrap">Questions: <b>{quiz.number_of_questions}</b></span>
              <span className="mx-2 text-border">|</span>
              <span className="whitespace-nowrap">Duration: <b>{quiz.quiz_duration} min</b></span>
              {isAdmin && (
                <>
                  <span className="mx-2 text-border">|</span>
                  <span>Eng</span>
                </>
              )}
            </div>
            {!isAdmin && (
              <div className="text-[10px] md:text-xs text-muted-foreground italic truncate">
                <span>Created: {moment(quiz.createdAt).format("DD-MM-YY")}</span>
                {quiz.appeared_on && <span> | Appeared: {moment(quiz.appeared_on).format("DD-MM-YY")}</span>}
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-3 w-full md:w-auto justify-end flex-shrink-0">
          {actions}
        </div>
      </CardContent>
    </Card>
  );
};

export default QuizCard;
